
import { axios } from "../axios.instance";

export enum ReportType {
  INAPPROPRIATE_CONTENT = "inappropriate-content",
  SPAM_OR_SCAMS = "spam-or-scams",
  THREATENING = "threatening",
  SELF_HARM = "self-harm",
  OTHER = "other",
}

export type ReportUserRequest = {
  userId: string;
  type: ReportType;
  description?: string;
};

export type ReportUserResponse = {
  id: string;
  type: ReportType;
  description: string;
  reportedUser: string;
  reportedBy: string;
};

export const reportUser = async (body: ReportUserRequest): Promise<ReportUserResponse> => {
  const { data } = await axios.post(`/reports/${body.userId}/report`, {
    type: body.type,
    description: body.description,
  });

  return data;
};
